import React from "react";

const Toggles = ({ toggleFor, ...props }) => {
  return (
    <label
      htmlFor={toggleFor}
      className="relative inline-flex items-center cursor-pointer"
    >
      <input
        type="checkbox"
        id={toggleFor}
        className="sr-only peer"
        {...props}
      />
      <div className="w-[34px] h-3 bg-[#9e9e9e] rounded-full peer peer-checked:bg-[#F6A78D]"></div>
      <div
        className="absolute left-0 top-1/2 bg-light_background_default drop-shadow-md
         w-5 h-5 rounded-full -translate-y-1/2 transition-transform shadow-toggle peer-checked:bg-themeBtn peer-checked:translate-x-[15px]"
      ></div>
    </label>
  );
};

export default Toggles;
